// $ 消息条的配置
import React from 'react'
import { useSnackbar, WithSnackbarProps, OptionsObject } from 'notistack';

interface IProps {
    setUseSnackbarRef: (showSnackbar: WithSnackbarProps) => void
}

const InnerSnackbarUtilsConfigurator: React.FC<IProps> = (props: IProps) => {
    props.setUseSnackbarRef(useSnackbar())
    return null
}

let useSnackbarRef: WithSnackbarProps
const setUseSnackbarRef = (useSnackbarRefProp: WithSnackbarProps) => {
    useSnackbarRef = useSnackbarRefProp
}

export const SnackbarUtilsConfigurator = () => {
    return <InnerSnackbarUtilsConfigurator setUseSnackbarRef={setUseSnackbarRef} />
}

const GlobalNotification = {
    success(message: string) {
        try {
            this.notification(`${message}`, { variant: 'success' });
        }
        catch (err) { }
    },
    warning(message: string) {
        try {
            this.notification(`${message}`, { variant: 'warning' });
        }

        catch (err) { }
    },
    info(message: string) {
        try {
            this.notification(`${message}`, { variant: 'info' });

        }

        catch (error) { }
    },
    error(message: string) {
        try {
            this.notification(`${message}`, { variant: 'error' });

        }

        catch (error) { }
    },
    notification(message: string, options?: OptionsObject) {
        const variant = options?.variant || 'default';
        try {
            useSnackbarRef.enqueueSnackbar(message, {
                ...options,
                variant,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                },
                autoHideDuration: 3000,
            });
        }

        catch (error) { }
    }
}

export default GlobalNotification